import { RESERVATION_URL } from "@/lib/constants";
import { trackClick } from "@/lib/analytics";

export default function BookButton({ className = "", label = "Book Direct & Save", variant = "ember", testid = "book-direct-btn" }) {
  const base = variant === "ink" ? "btn-ink" : "btn-ember";
  return (
    <a
      href={RESERVATION_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`${base} ${className}`}
      data-testid={testid}
      onClick={() => trackClick(`book:${testid}`)}
      aria-label="Book your stay directly with Westbridge Inn & Suites — opens reservation system in a new tab"
    >
      <span>{label}</span>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
        <path d="M5 12h14M13 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </a>
  );
}
